module.exports = __webpack_public_path__ + "static/media/DSC00004.dc88acfb.jpg";